import clsx from 'clsx'

import Icon from './Icon'

export default function Progress({className}: {className?: string}) {
    return <Icon role='progressbar' name='progress' className={clsx('progress', className)}/>
}
